var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-flex align-center"},[(_vm.isLoading)?void 0:[_c('h3',_vm._b({staticClass:"mb-0 px-2 editable-element",class:{
        focused: _vm.isEditable,
      },attrs:{"contenteditable":_vm.isEditable},domProps:{"textContent":_vm._s(_vm.editableText)},on:{"blur":_vm.onBlue,"input":_vm.onInput}},'h3',{
        ..._vm.$attrs,
      },false)),(_vm.error)?_c('h3',{staticClass:"my-0 red--text"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),(!_vm.isEditable)?_c('v-icon',{staticClass:"cursor-pointer ml-2",attrs:{"size":"18","color":"blue"},on:{"click":_vm.makeEditable}},[_vm._v("mdi-pencil")]):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }